import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import SubcategoryCardGrid from 'components/nav/shared/SubcategoryCardGrid';
import SubcategoryCard from 'components/nav/shared/SubcategoryCard';
import DesktopNavCategorySectionImage from 'components/nav/DesktopHeader/components/DesktopNavCategorySectionImage';
const DesktopNavCategorySectionContent = t0 => {
  const $ = _c(24);
  const {
    categoryDescription,
    categoryImage,
    categoryImageLabel,
    categoryUrl,
    contentId,
    customContent,
    onMouseEnter,
    onMouseLeave,
    selectedSubcategory,
    selectedSubcategoryItems
  } = t0;
  const imageToDisplay = selectedSubcategory?.image || categoryImage;
  const imageToDisplayLabel = selectedSubcategory?.label || categoryImageLabel;
  const imageToDisplayLink = selectedSubcategory?.url || categoryUrl;
  const imageDescription = selectedSubcategory?.description || categoryDescription;
  const imageDescriptionTextColor = selectedSubcategory?.descriptionTextColor;
  const t1 = `w-[635px] ${contentId.includes("decor") ? "!w-[540px]" : ""}`;
  let t2;
  if ($[0] !== contentId || $[1] !== onMouseEnter || $[2] !== onMouseLeave || $[3] !== t1) {
    t2 = {
      className: t1,
      "data-nested-popup": "true",
      id: contentId,
      onMouseEnter,
      onMouseLeave
    };
    $[0] = contentId;
    $[1] = onMouseEnter;
    $[2] = onMouseLeave;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const wrapperProps = t2;
  if (selectedSubcategoryItems) {
    let t3;
    if ($[5] !== selectedSubcategoryItems) {
      t3 = selectedSubcategoryItems.map(_temp);
      $[5] = selectedSubcategoryItems;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== t3) {
      t4 = <SubcategoryCardGrid>{t3}</SubcategoryCardGrid>;
      $[7] = t3;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== t4 || $[10] !== wrapperProps) {
      t5 = <div {...wrapperProps}>{t4}</div>;
      $[9] = t4;
      $[10] = wrapperProps;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  if (customContent) {
    let t3;
    if ($[12] !== customContent || $[13] !== wrapperProps) {
      t3 = <div {...wrapperProps}>{customContent}</div>;
      $[12] = customContent;
      $[13] = wrapperProps;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    return t3;
  }
  if (imageToDisplay) {
    let t3;
    if ($[15] !== imageDescription || $[16] !== imageDescriptionTextColor || $[17] !== imageToDisplay || $[18] !== imageToDisplayLabel || $[19] !== imageToDisplayLink) {
      t3 = <DesktopNavCategorySectionImage description={imageDescription} descriptionTextColor={imageDescriptionTextColor} image={imageToDisplay} label={imageToDisplayLabel} to={imageToDisplayLink} />;
      $[15] = imageDescription;
      $[16] = imageDescriptionTextColor;
      $[17] = imageToDisplay;
      $[18] = imageToDisplayLabel;
      $[19] = imageToDisplayLink;
      $[20] = t3;
    } else {
      t3 = $[20];
    }
    let t4;
    if ($[21] !== t3 || $[22] !== wrapperProps) {
      t4 = <div {...wrapperProps}>{t3}</div>;
      $[21] = t3;
      $[22] = wrapperProps;
      $[23] = t4;
    } else {
      t4 = $[23];
    }
    return t4;
  }
  return null;
};
DesktopNavCategorySectionContent.propTypes = {
  categoryDescription: PropTypes.string,
  categoryImage: PropTypes.string,
  categoryImageLabel: PropTypes.string,
  categoryUrl: PropTypes.string,
  contentId: PropTypes.string,
  customContent: PropTypes.node,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  selectedSubcategory: PropTypes.shape({
    description: PropTypes.string,
    descriptionTextColor: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string,
    url: PropTypes.string
  }),
  selectedSubcategoryItems: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string,
    url: PropTypes.string
  }))
};
export default DesktopNavCategorySectionContent;
function _temp(t0) {
  const {
    id: subcategoryId,
    image: subcategoryImage,
    label,
    url
  } = t0;
  return <SubcategoryCard key={subcategoryId} image={subcategoryImage} label={label} to={url} />;
}